// extracted by mini-css-extract-plugin
export default {"subabout_wrapper":"subabout_subabout_wrapper__4vnlW","subabout_info":"subabout_subabout_info__0McGh"};